/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { persistore, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import { fetchMachines } from './redux/reducers/machines';
import { fetchSoftware } from 'redux/reducers/softwares';
import { fetchFairs } from 'redux/reducers/fairs';
import { fetchUser } from 'redux/reducers/user';

store.dispatch(fetchMachines);
store.dispatch(fetchSoftware);
store.dispatch(fetchFairs);
store.dispatch(fetchUser);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistore}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
